import React from 'react';
export default function TransferRing({ progress = 0, size = 48 }) {
  const value = Math.max(0, Math.min(1, progress));
  return <svg width={size} height={size} viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true"
    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none', color: '#33b6df' }}>
    <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeOpacity=".2" strokeWidth="3" />
    <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="3" pathLength="1"
      strokeDasharray={`${value} 1`} transform="rotate(-90 50 50)" />
  </svg>;
}
